import {styles} from "./ModelAPdf";
import {Document, Line, Page, Svg, Text, View} from "@react-pdf/renderer";

export function OccActiPdf(props) {
    const {occActiTempObject} = props;
    return <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Occasionele activiteit</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Provincie: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.provincie}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Sector: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.sector}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Club: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.club}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Stam nr: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.stamNr}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Secretaris</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.secretarisNaam}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.secretarisVoornaam}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.secretarisStraat}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.secretarisNr}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.secretarisPostnr}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.secretarisGemeente}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel/Gsm/Fax: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.secretarisTelGsmFax}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Aanwezige verantwoordelijke</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.verantNaam}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.verantVoornaam}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.verantStraat}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.verantNr}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.verantPostnr}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.verantGemeente}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel/Gsm/Fax: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.verantTelGsmFax}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Datum activiteit: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.datumActiv}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Locatie activiteit: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.locatieActiv}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Uur activiteit: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.naamActiv}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Adres activiteit: </Text>
                            <Text style={styles.fieldText}>{occActiTempObject.adresActiv}</Text>
                        </View>
                    </View>

                </View>
                <View style={styles.col}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Fax activiteit: </Text>
                        <Text style={styles.fieldText}>{occActiTempObject.telGsmFaxActiv}</Text>
                    </View>
                </View>
                <View style={styles.col}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Omschrijving activiteit: </Text>
                        <Text style={styles.fieldText}>{occActiTempObject.omschrijvingActiv}</Text>
                    </View>
                </View>
            </View>
        </Page>
    </Document>
}